<template>
    <div>
        <div style="border: 1px solid #eee; margin: 10px 0">
            <div class="productSpec">
                <p></p>
                <dl>
                    <dt>长*宽*高</dt>
                    <dd>{{modelDesc.length+'mm&nbsp;*&nbsp;'+modelDesc.width+'mm&nbsp;*&nbsp;'+modelDesc.height+'mm'}}</dd>
                </dl>
            </div>
            <div class="productSpec">
                <p></p>
                <dl>
                    <dt>重量</dt>
                    <dd>{{modelDesc.weight+'KG' + '&nbsp;±&nbsp;'+modelDesc.weightDeviation}}KG</dd>
                </dl>
            </div>
            <div class="productSpec" v-show="modelDesc.deadLoad">
                <p></p>
                <dl>
                    <dt>静载</dt>
                    <dd>{{modelDesc.deadLoad}}KG</dd>
                </dl>
            </div>
            <div class="productSpec" v-show="modelDesc.dynamicLoad">
                <p></p>
                <dl>
                    <dt>动载</dt>
                    <dd>{{modelDesc.dynamicLoad}}KG</dd>
                </dl>
            </div>
            <div class="productSpec">
                <p></p>
                <dl>
                    <dt>成型工艺</dt>
                    <dd>{{$options.filters['queryDict']('target', 'processTech', modelDesc.processTech)}}</dd>
                </dl>
            </div>
            <div class="productSpec">
                <p></p>
                <dl>
                    <dt>加工工艺</dt>
                    <dd>{{$options.filters['queryDict']('target', 'moldTech', modelDesc.moldTech)}}</dd>
                </dl>
            </div>
            <div class="productSpec" v-for="component in modelDesc.componentList" :key="component.materialTypeName" v-show="component.priceMode == 'MATERIAL'">
                <p></p>
                <dl>
                    <dt>{{component.materialTypeName}}</dt>
                    <dd>{{component.materialAmount*component.componentQuantity}}kg</dd>
                </dl>
            </div>
            <div class="productSpec" v-for="(component, index) in modelDesc.componentList" :key="index" v-show="component.priceMode == 'SINGLE'">
                <p></p>
                <dl>
                    <dt>{{component.componentName}}</dt>
                    <dd>{{component.componentQuantity}}个</dd>
                </dl>
            </div>
            <div style="text-align:center;margin-top:20px" v-for="item in descImageList" :key="item.filePath">
                <img v-lazy="item.filePath" />
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: ['targetModelCode', 'descImageList'],

    data() {
        return {
            modelDesc: {},//规格
        }
    },

    async beforeCreate() {
        await this.dict.initDict([
            { id: 'processTech', namespace: 'target' },
            { id: 'moldTech', namespace: 'target' },
        ]);
    },
    watch: {
        'targetModelCode': function (newVal, oldVal) {
            if (newVal) {
                this.queryTargetModel(newVal);
            }
        }
    },
    methods: {
        queryTargetModel(targetModelId) {
            let data = {
                url: 'http://CORE-TARGET/messageService/baseInfoService/queryTargetModel',
                body: { targetModelId }
            }

            this.invoke(data).then(rs => {
                this.modelDesc = rs
            })
        },

    }

}
</script>

<style lang="scss" scoped>
.productSpec:first-child {
    margin: 20px 0 0 10px;
}
.productSpec:last-of-type {
    padding-bottom: 20px;
}

.productSpec {
    width: 100%;
    display: flex;
    margin: 5px 0 0 10px;
    color: #666;
    // font-size: 12px;

    p {
        width: 70px;
        font-size: 12px;
        color: #666;
    }
    dl {
        display: flex;
        width: 100%;
        dt {
            width: 160px;
            text-align: right;
            margin-right: 30px;
        }
        dd {
            width: 100%;
            text-align: left;
        }
    }
}
img[lazy="loading"] {
    display: block;
    width: 100px;
    height: 100px;
    margin: 100px auto;
}
img[lazy="loaded"] {
    width: 700px;
}
</style>